export default __webpack_public_path__ + "static/media/copy.38a68b1e.svg";